import {Button, Text} from '@mantine/core'
import {type ReactNode, useState} from 'react'

import classes from './dispatch.module.css'

export function CleanUpSection({count, children}: {count: number; children: ReactNode}) {
    const [open, setOpen] = useState(false)
    if (count === 0) {
        return null
    }

    return (
        <section data-testid="clean-up-section">
            <div className={`${classes['sectionHeader']} ${classes['sectionHeaderCleanUp']}`}>
                <div className={classes['sectionHeaderLeading']}>
                    <span
                        className={`${classes['sectionAccent']} ${classes['sectionAccentCleanUp']}`}
                        aria-hidden
                    />
                    <span className={classes['sectionLabel']}>Clean-up</span>
                    <span
                        className={`${classes['sectionCount']} ${classes['sectionCountCleanUp']}`}
                    >
                        {count}
                    </span>
                </div>
                <Button
                    size="compact-xs"
                    variant="subtle"
                    aria-expanded={open}
                    onClick={() => setOpen((value) => !value)}
                >
                    {open ? 'Hide' : 'Show'}
                </Button>
            </div>
            <Text size="sm" c="dimmed" px="md" py="xs">
                Open jobs that ended before yesterday. Complete them or extend the end date
            </Text>
            {open && <div className={classes['laneBody']}>{children}</div>}
        </section>
    )
}
